module.exports = __webpack_public_path__ + "static/media/empty-dashboard-image.8272c205.svg";